const link = "_35sl3hdkkp";

export { link };
import "./link.style.linaria.module.css";
//# sourceMappingURL=link.style.js.map
